<template>
  <div>
    <h1>Survey plot</h1>
    <h3>Clicked id: {{ selectedId }}</h3>
    <tree :root="backendTree" />
    <h1>Survey raw</h1>
    <div v-if="selectedId">
      <v-btn @click="removeQuestion()">
        <v-icon left>mdi-minus</v-icon>
        verwijder
      </v-btn>
      <v-btn @click="editDialog=true">
        <v-icon left>mdi-pencil</v-icon>
        wijzig
      </v-btn>
      <v-btn @click="addDialog=true">
        <v-icon left>mdi-plus</v-icon>
        voeg toe na
      </v-btn>
    </div>
    <v-simple-table>
      <template v-slot:default>
        <thead>
        <tr>
          <th>id</th>
          <th>type</th>
          <th>required</th>
          <th>question</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="question in questions" :key="question.id" :class="{'selected': isSelected(question.id)}">
          <td>{{ question.id }}</td>
          <td>{{ question.type }}</td>
          <td>{{ question.required ? "yes" : "no" }}</td>
          <td>{{ question.question }}</td>
          <td>
            <v-btn @click="setIdOnly({id: question.id})">select</v-btn>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-dialog v-model="addDialog" hide-overlay fullscreen>
      <v-card>
        <question-builder :survey="questions" :questionId="selectedId" v-model="addDialog" />
      </v-card>
    </v-dialog>

    <v-dialog v-model="editDialog" hide-overlay fullscreen>
      <v-card>
        <question-builder :survey="questions" :questionId="selectedId" v-model="editDialog" isEdit />
      </v-card>
    </v-dialog>

    <h1>Selected question</h1>
    <question-card v-if="resolveQuestion(selectedId)" :question="resolveQuestion(selectedId)"></question-card>

    <v-snackbar
      v-model="showSnackbar"
      :timeout="2000"
    >
      {{ errorMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="showSnackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

  </div>
</template>
<style scoped>
  div {
    overflow-x: auto;
  }
</style>
<script>
import {mapActions, mapGetters} from 'vuex';
import Tree from '@/components/Tree';
import {questionService} from '@/services/question';
import QuestionCard from '@/components/QuestionCard';
import {Question, QuestionTypeEnum} from '@/shared/question';
import QuestionBuilder from '@/components/question-editor/QuestionBuilder';


export default {
    name: 'about',
    components: { QuestionBuilder, Tree, QuestionCard },
    data() {
      return {
        addDialog: false,
        editDialog: false,
        backendTree: null,
        showSnackbar: false,
        errorMessage: 'Je kan dit onderdeel niet verwijderen',
        questions: [],
      };
    },
    methods: {
      ...mapActions(['loadSurvey', 'setIdOnly']),
      resolveFlow() {
        this.loadSurvey({ 'clientId': this.$route.params.clientId, 'surveyId': this.$route.params.surveyId });
        questionService.resolveFlow(this.clientId, this.surveyId)
          .then(e => this.backendTree = e.data);
        questionService.resolveSurvey(this.clientId, this.surveyId)
          .then(e => this.questions = e.data);
      },
      removeQuestion() {
        const question = this.resolveQuestion(this.selectedId);
        if (question.type === QuestionTypeEnum.END_SURVEY) {
          this.showSnackbar = true;
          return;
        }

        questionService.deleteQuestion(this.clientId, this.surveyId, this.selectedId)
          // eslint-disable-next-line no-unused-vars
          .then(e => this.resolveFlow());
      },
      resolveQuestion(id) {
        if (id === '') {
          return null;
        }
        return this.questions.filter(e => e.id === id)
          .map(e => JSON.stringify(e))
          .map(e => Question.from(e))[0];
      },
      isSelected(id) {
        return this.selectedId === id;
      },
    },
    computed: {
      ...mapGetters(['selectedId', 'contextMenuIsOpen', 'clientId', 'surveyId']),
    },
    created() {
      this.resolveFlow();
      // eslint-disable-next-line no-unused-vars
      this.$on('renderquestionflow', e => {
        this.resolveFlow();
      });
    },
  };
</script>
<style scoped>
  tr.selected {
    color: var(--v-primary-base);
  }
</style>

